import React, { useEffect, useRef, useState } from "react";
import OpenInFullIcon from "@mui/icons-material/OpenInFull";
import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import VectorSource from "ol/source/Vector";
import VectorLayer from "ol/layer/Vector";
import MapFullScreen from "../../map/mapFullScreen";
import useOpenLayersMap from "../../hooks/useOpenLayersMap";
import useFullScreenElement from "../../hooks/useFullscreenElement";
import { createEmpty, extend } from "ol/extent";

const AirspaceCharacterizationMapPreview = ({ id, features }) => {
    const [tooltip, setTooltip] = useState("");

    const tooltipRef = useRef();
    const mapWrapperRef = useRef();

    const map = useOpenLayersMap(id, false);
    const mapContainer = useFullScreenElement();

    useEffect(() => {
        if (!map) return;

        // add features
        const vectorSource = new VectorSource({
            features: features
        });
        const vectorLayer = new VectorLayer({
            source: vectorSource
        });
        map.addLayer(vectorLayer);

        // zoom to features
        if (Array.isArray(features) && features.length > 0) {
            const extent = createEmpty();
            features.forEach((feature) => {
                extend(extent, feature.getGeometry().getExtent());
            });
            map.getView().fit(extent, {
                padding: [25, 25, 25, 25]
            });
        }

        // add hover functionality
        map.on("pointermove", ({ pixel }) => {
            map.forEachFeatureAtPixel(pixel, (feature) => {
                const properties = feature.getProperties();
                if (properties && properties.geometry) {
                    map.getTargetElement().style.cursor = "pointer";

                    if (Array.isArray(properties.heatmap_stats) === false) {
                        return false;
                    }
                    const stats = properties.heatmap_stats.find(({ name }) => {
                        return name === id;
                    });
                    if (stats && tooltipRef && tooltipRef.current) {
                        tooltipRef.current.style.left = pixel[0] + 15 + "px";
                        tooltipRef.current.style.top = pixel[1] - 15 + "px";
                        setTooltip(stats.value || "0");
                        return true;
                    }
                } else {
                    map.getTargetElement().style.cursor = "default";
                    setTooltip("");
                }
            });
        });
    }, [map]);

    const handleFullScreenButtonClick = () => {
        try {
            if (mapContainer) {
                document.exitFullscreen();
            } else {
                mapWrapperRef.current.requestFullscreen();
            }
        } catch (err) {
            console.error(err);
        }
    };
    return (
        <Box ref={mapWrapperRef} sx={{ position: "relative", width: "100%", height: "100%" }}>
            <MapFullScreen
                map_id={id}
                map={map}
                buttons={[
                    {
                        name: mapContainer ? "Exit Fullscreen" : "Enter Fullscreen",
                        visible: true,
                        icon: mapContainer ? <CloseIcon /> : <OpenInFullIcon />,
                        onClick: handleFullScreenButtonClick
                    }
                ]}
            />

            <Paper ref={tooltipRef} sx={{ p: 1, position: "absolute", display: tooltip ? "block" : "none" }}>
                <Typography variant="body1">{tooltip}</Typography>
            </Paper>
        </Box>
    );
};

export default AirspaceCharacterizationMapPreview;
